import React from "react";

const HtmlField = ({id, name, input_type, description, value, options, onChange, required, errors}) => {
    return (
        <p dangerouslySetInnerHTML={{__html: description}}/>
    )
}

export default HtmlField;
